import {put, call} from 'redux-saga/effects'
import {showErrorFlashMessage} from 'actions/flashMessage'

export const showBackendErrors = function* (error, reject) {
  yield put(showErrorFlashMessage(error.message))
  yield call(reject, error)
}
